export enum AuthApplicationKeys {
    PetPass = '059710B6-E0A7-E911-A79B-000D3A52D59C',
    SWIFT = '8BD7A87F-C14A-47B5-98F3-E5C41C54F2B1',
    Admin = 'C30CD63D-0657-41A0-9D92-61AD13B5E125'
}
